import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchEmployeeList = createAsyncThunk('getPartialEmployeeData/fetchEmployeeList',
  async ({page,SB,order,size}, { rejectWithValue }) => {
    try {
      // Use Math.max to ensure we never go below 0
      const sanitizedPage = Math.max(0, page - 1);
      const url = `${api.getPartialCandidateData}?type=1&page=${sanitizedPage}&size=${size}&sortBy=${SB}&direction=${order}`
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const getEmployeeListSlice = createSlice({
  name: 'employees',
  initialState: {
    employees: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchEmployeeList.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchEmployeeList.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.employees = action.payload;
        })
      .addCase(fetchEmployeeList.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getEmployeeListSlice.reducer;